// Détection d'un CSV qui n'est pas un export de comptes prop firm.
//
// Le parseur est positionnel : un fichier d'un autre format n'est pas rejeté
// globalement, il produit une erreur par cellule mal typée. Un utilisateur qui
// déposait son export de TRADES ici recevait donc des dizaines de lignes
// "date YYYY-MM-DD attendue, valeur trouvée : 29883.50" — techniquement exact,
// mais sans jamais lui indiquer qu'il s'était trompé de formulaire.
//
// On regarde la ligne d'en-tête : si elle ne reconnaît AUCUNE colonne du
// format attendu, le fichier n'est presque sûrement pas destiné à cet import.

/** Colonnes du template (actuel et ancien) servant de signature. */
const KNOWN_COLUMNS = new Set([
  "propfirm",
  "nom_compte",
  "tiers",
  "taille_compte",
  "prix_usd",
  "groupe",
  "strategie",
  "frais_activation",
  "date_achat",
  "date_cloture",
]);

function normalize(value: string): string {
  return value.trim().toLowerCase();
}

/**
 * La première ligne ressemble-t-elle à un en-tête d'un AUTRE format ?
 *
 * Renvoie `true` seulement si la ligne ressemble à un en-tête (des libellés,
 * pas des données) ET qu'aucune colonne connue n'y figure. Volontairement
 * conservateur : le parseur positionnel accepte un fichier sans en-tête, et un
 * faux positif bloquerait un import légitime.
 */
export function detectWrongCsvFormat(headerRow: string[] | undefined): boolean {
  if (!headerRow || headerRow.length === 0) return false;

  const cells = headerRow.map(normalize).filter((c) => c !== "");
  if (cells.length === 0) return false;

  // Une colonne connue suffit à considérer que l'utilisateur vise ce
  // formulaire, même avec un fichier incomplet ou aux colonnes réordonnées.
  if (cells.some((c) => KNOWN_COLUMNS.has(c))) return false;

  // Aucune colonne reconnue. Reste à distinguer un en-tête étranger d'une
  // première ligne de DONNÉES (fichier sans en-tête, que le parseur sait
  // traiter). Un en-tête est fait de libellés : pas de nombres, pas de dates.
  const looksLikeLabels = cells.every(
    (c) => !/^\d/.test(c) && !/^\d{4}-\d{2}-\d{2}/.test(c),
  );

  return looksLikeLabels;
}
